import { Controller } from '@hotwired/stimulus'

// Form controller for form handling
// Usage: <form data-controller="form" data-action="submit->form#submit">
export default class extends Controller {
  static targets = ['submit', 'error']
  static values = {
    submitText: { type: String, default: 'Сохранить' },
    loadingText: { type: String, default: 'Сохранение...' }
  }

  connect () {
    this.originalSubmitText = this.hasSubmitTarget ? this.submitTarget.textContent : null
  }

  submit (event) {
    // Disable submit button and show loading state
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = true
      this.submitTarget.textContent = this.loadingTextValue
    }
  }

  // Called by Turbo on form submission error
  submitError (event) {
    this.resetSubmitButton()
  }

  // Called by Turbo on form submission end
  submitEnd (event) {
    // Re-enable submit button after a short delay
    setTimeout(() => {
      this.resetSubmitButton()
    }, 100)
  }

  resetSubmitButton () {
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = false
      this.submitTarget.textContent = this.originalSubmitText || this.submitTextValue
    }
  }

  // Clear all error messages
  clearErrors () {
    this.errorTargets.forEach(el => {
      el.textContent = ''
      el.classList.add('hidden')
    })

    // Remove is-invalid class from inputs
    this.element.querySelectorAll('.is-invalid').forEach(el => {
      el.classList.remove('is-invalid')
    })
  }

  // Show error for specific field
  showError (event) {
    const { field, message } = event.detail
    const input = this.element.querySelector(`[name="${field}"]`)

    if (input) {
      input.classList.add('is-invalid')
      const errorEl = input.parentElement.querySelector('.invalid-feedback')
      if (errorEl) {
        errorEl.textContent = message
        errorEl.classList.remove('hidden')
      }
    }
  }
}
